import { useEffect, useState } from "react";
import { ArrowUp, Phone, MessageCircle } from "lucide-react";
import { CONTACT, buildWhatsAppLink } from "@/data/site";

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-6 left-6 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={buildWhatsAppLink("Hello NEPHRC, I'd like to discuss a project.")}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        className="group w-14 h-14 grid place-items-center bg-emerald-brand text-white shadow-2xl hover:scale-105 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle size={22} />
      </a>
      <a
        href={`tel:${CONTACT.primaryPhone}`}
        data-testid="floating-call"
        className="w-14 h-14 grid place-items-center bg-navy text-white shadow-2xl hover:scale-105 transition-transform"
        aria-label="Call"
      >
        <Phone size={20} />
      </a>
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="floating-back-to-top"
          className="w-14 h-14 grid place-items-center bg-gold text-navy shadow-2xl hover:scale-105 transition-transform"
          aria-label="Back to top"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
}
